import { v4 as uuid } from 'uuid';

/**
 * Props for all StickyAlerts.
 * This is an interface because `defineProps` only works with interfaces.
 */
export interface StickyAlertPropsSchema {
  id: string;
}

export default class StickyAlertProps implements StickyAlertPropsSchema {
  id: string;

  constructor() {
    this.id = uuid();
  }
}
